// 散点图PCA
import ChartTemplate from '../ChartTemplate';
import $ from '@/assets/jquery/jquery-vendor.js';
import { SVG } from '@svgdotjs/svg.js';
import '@svgdotjs/svg.draggable.js';

// ==============  三维散点图的拖动
function bindMouseRotation (chart) {
  $(chart.container).bind('mousedown.hc touchstart.hc', function (e) {
    var posX = e.pageX, posY = e.pageY, alpha = chart.options.chart.options3d.alpha, beta = chart.options.chart.options3d.beta, newAlpha, newBeta, sensitivity = 3; // lower is more sensitive
    $(document).bind({
      'mousemove.hc touchdrag.hc': function (e) {
        newBeta = beta + (posX - e.pageX) / sensitivity;
        chart.options.chart.options3d.beta = newBeta;
        newAlpha = alpha + (e.pageY - posY) / sensitivity;
        chart.options.chart.options3d.alpha = newAlpha;
        chart.redraw(false);
      },
      'mouseup touchend': function () { $(document).unbind('.hc') }
    });
  });
}
// ==============  解除三维拖动绑定
function unBindMouseRotation (chart) { $(chart.container).unbind('mousedown.hc touchstart.hc') }


export default {
  extends: ChartTemplate,
  props: {
    formButtons: {
      default: function () { return [{ embed: true, code: 'ss', name: '标记', click: () => this.onShowSs() }] }
    },
    config: {
      default: function () { return { name: 0, group: 1, z: -1 } }
    }
  },
  data () {
    return {
      axisCoder: [], xIndex: -1, yIndex: -1, zIndex: -1, groupIndex: -1,
      ss: [], ssVisible: false,
      extCPT: () => import('./ExtendComponent.vue'),
      extCPTValue: false
    }
  },
  computed: {
    extCPTProps () { return { items: this.ss, z: this.zIndex } }
  },
  methods: {
    onOpenParamDialog (v) {
      if (v) {
        this.$nextTick(() => {
          if (!this.paramDialogInit) {
            this.setFormDataCoder();
            this.$refs.paramForm.setFormData(this.paramFormData);
            this.paramDialogInit = true;
          }
          this.Utility.dragDialog(`${this.chartElId}_paramCard`)
        })
      }
    },
    initParamAfter () {
      this.initAxisCoder();
      this.setFormDataCoder();
      if (!this.embed) {
        let form = this.$refs.paramForm;
        let axisDefaultValues = { xColumn: this.xIndex, yColumn: this.yIndex, zColumn: this.zIndex };
        form.setItemValue(axisDefaultValues);
      }
    },
    initOptionAfter () {
      this.initDimOption();
    },
    onParamFormChangedBefore (e, item) {
      let code = item.code;
      if (code == 'xColumn' || code == 'yColumn' || code == 'zColumn') {
        this.ss = [];
        if (code == 'xColumn') this.xIndex = e;
        else if (code == 'yColumn') this.yIndex = e;
        else if (code == 'zColumn') this.zIndex = e >= 0 ? e : -1;
        if (this.xIndex == this.yIndex || this.xIndex == this.zIndex || this.yIndex == this.zIndex) {
          this.$message.error('请选择不同PC进行绘图');
          return false;
        }
        this.config.x = this.xIndex;
        this.config.y = this.yIndex;
        this.config.z = this.zIndex;
        this.initParamOption();
        this.initOption();
        this.initDimOption();
        this.initChart();
        this.initChartAfter();
        if (this.zIndex == -1) unBindMouseRotation(this.chart);
        else bindMouseRotation(this.chart);
        return false;
      }
    },
    onParamFormChangedAfter (value, item) {
      if (item.code == 'SampleLabel') {
        let ls = $('.highcharts-data-labels');
        if (ls.length) for (let i = 0; i < ls.length; i++) ls[i].onmouseover = null;
      }
    },
    initChartAfter () {
      this.drawBorder();
      if (this.zIndex != -1) bindMouseRotation(this.chart);
    },


    // ============= 合并二维或三维的option
    initDimOption () {
      let option;
      if (this.config.z == null || this.config.z == -1) {
        option = this.getChartOption_2D();
      } else {
        option = this.getChartOption_3D();
      }
      this.Utility.deepMerge(this.chartOption, option);
    },
    // ============= 获取二维chartOption
    getChartOption_2D () {
      let xTitle = this.axisCoder.find(c => c.code == this.config.x).name, yTitle = this.axisCoder.find(c => c.code == this.config.y).name;
      return {
        chart: { options3d: { enabled: false } },
        plotOptions: { series: { stickyTracking: false, dataLabels: { allowOverlap: true, format: '{point.name}' } }, scatter: { animation: false, point: { events: { click: this.pointClick, mouseOver: function () { } } } } },
        xAxis: {
          gridLineWidth: 0,
          title: { text: xTitle },
          // tickPositioner: function () {
          //   let stp = this.tickPositions;
          //   let sep = stp.length > 1 ? stp[1] - stp[0] : 1;
          //   stp.unshift(stp[0] - sep);
          //   stp.push(stp[stp.length - 1] + sep);
          //   this.min = stp[0];
          //   this.max = stp[stp.length - 1];
          //   return stp;
          // }
        },
        legend: { enabled: true },
        yAxis: { title: { text: yTitle } },
      }
    },
    // ============= 获取三维chartOption
    getChartOption_3D () {
      let xTitle = this.axisCoder.find(c => c.code == this.config.x).name, yTitle = this.axisCoder.find(c => c.code == this.config.y).name, zTitle = this.axisCoder.find(c => c.code == this.config.z).name;
      return {
        chart: {
          options3d: {
            enabled: true, alpha: 10, beta: 30, depth: 250, viewDistance: 5,
            frame: {
              bottom: { size: 1, color: 'rgba(0,0,0,0.02)' },
              back: { size: 1, color: 'rgba(0,0,0,0.02)' },
              side: { size: 1, color: 'rgba(0,0,0,0.02)' }
            }
          }
        },
        plotOptions: { series: { stickyTracking: false, dataLabels: { allowOverlap: true, format: '{point.name}' } }, scatter3d: { animation: false, point: { events: { click: this.pointClick } } } },
        xAxis: { title: { text: xTitle }, gridLineWidth: 1 },
        yAxis: { title: { text: yTitle }, gridLineWidth: 1 },
        zAxis: { title: { text: zTitle }, gridLineWidth: 1 },
        legend: { enabled: true }
      }
    },

    // ============== 获取绘图轴的下拉选项列表
    initAxisCoder () {
      let headers = this.dataSource[0];
      let axisCoder = [];
      for (let i = 1, l = headers.length; i < l; i++) {
        let t = headers[i];
        if (t.toLowerCase().startsWith('group')) this.groupIndex = i;
        if (t && !t.toLowerCase().startsWith('group')) axisCoder.push({ code: i, name: t });
      }
      this.axisCoder = axisCoder;
      this.xIndex = axisCoder[0].code;
      this.yIndex = axisCoder[1].code;
      this.config.x = this.xIndex;
      this.config.y = this.yIndex;
      if (this.config.z != -1) this.zIndex = this.config.z;
    },
    // ================ 设置表单的下拉选项
    setFormDataCoder () {
      let form = this.$refs.paramForm;
      if (form) {
        form.setCoder('xColumn', this.axisCoder);
        form.setCoder('yColumn', this.axisCoder);
        form.setCoder('zColumn', this.axisCoder);
      }
      this.paramFormData.xColumn = this.xIndex;
      this.paramFormData.yColumn = this.yIndex;
      this.paramFormData.zColumn = this.zIndex;
    },
    // ======================= 绘制边框
    drawBorder () {
      let background = this.chart.container.getElementsByClassName('highcharts-plot-background');
      if (this.config.z == null || this.config.z == -1) {
        background[0].setAttribute('stroke', '#000000');
      } else {
        background[0].removeAttribute('stroke');
      }
    },

    // ============================ 点标记
    pointClick (e) {
      let point = e.point;
      if (this.ss.indexOf(point) == -1) {
        let dataLabels = { enabled: true, shape: 'callout', borderWidth: 1, borderColor: '#1976D2', x: 50 };
        point.update({ dataLabels: dataLabels });
        this.ss.push(point);
        this.initDataLabelListener(point);
      } else {
        this.ss.splice(this.ss.indexOf(point), 1);
        point.update({ dataLabels: { enabled: false } });
      }
    },
    initDataLabelListener (point) {
      let $g = SVG(point.dataLabel.element); // {g:[path,{text:[tspan,tspan]}]}
      let $text = $g.children()[1];
      $text.plain($text.children()[0].text());
      let $path = $g.children()[0];
      let _bps = $path.array().filter(a => a[0] != 'C');
      let w = Math.abs(_bps[1][1] - _bps[0][1]), h = Math.abs(_bps[2][2] - _bps[1][2]), cx, cy;
      if (_bps.length > 6) cx = _bps[5][1], cy = _bps[5][2];
      else {
        let $point = SVG(point.graphic.element);
        let pcx = $point.cx(), pcy = $point.cy();
        let gTrans = $g.transform();
        cx = Math.abs(pcx - gTrans.translateX), cy = Math.abs(pcy - gTrans.translateY);
      }
      let x1, y1, x, y, textX, textY;
      $text.draggable().on('beforedrag', e => {
        x1 = e.detail.event.x; y1 = e.detail.event.y;
        let ds = $path.array()[0];
        x = ds[1]; y = ds[2];
        textX = e.target.instance.x(); textY = e.target.instance.y();
      }).on('dragmove', e => {
        let x2 = e.detail.event.x, y2 = e.detail.event.y;
        let ex = x2 - x1, ey = y2 - y1;
        let nx = x + ex, ny = y + ey;
        let p1 = { x: nx, y: ny }, p2 = { x: nx + w, y: ny }, p3 = { x: nx + w, y: ny + h }, p4 = { x: nx, y: ny + h };
        let cp1 = { x: p1.x + (p2.x - p1.x) / 2, y: p1.y }, cp2 = { x: p2.x, y: p2.y + (p3.y - p2.y) / 2 }, cp3 = { x: p4.x + (p3.x - p4.x) / 2, y: p3.y }, cp4 = { x: p1.x, y: p1.y + (p4.y - p1.y) / 2 };
        let cpp = { x: cx, y: cy };
        let dis1 = this.getDistance(cpp, cp1), dis2 = this.getDistance(cpp, cp2), dis3 = this.getDistance(cpp, cp3), dis4 = this.getDistance(cpp, cp4);
        let minDis = Math.min(dis1, dis2, dis3, dis4);
        let d;
        if (minDis == dis1) { // 连接矩形的上边
          d = `M ${p1.x} ${p1.y} L ${p1.x + (p2.x - p1.x) / 2} ${p1.y} L ${cx} ${cy} L ${p1.x + (p2.x - p1.x) / 2} ${p1.y} L ${p2.x} ${p2.y} L ${p3.x} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y}`;
        } else if (minDis == dis2) {  // 连接矩形的右边
          d = `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y} L ${p2.x} ${p2.y + (p3.y - p2.y) / 2} L ${cx} ${cy} L ${p2.x} ${p2.y + (p3.y - p2.y) / 2} L ${p3.x} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y}`;
        } else if (minDis == dis3) {  // 连接矩形的下边
          d = `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y} L ${p3.x} ${p3.y} L ${p4.x + (p3.x - p4.x) / 2} ${p3.y}  L ${cx} ${cy} L ${p4.x + (p3.x - p4.x) / 2} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y}`;
        } else if (minDis == dis4) { // 连接矩形的左边
          d = `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y} L ${p3.x} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y + (p4.y - p1.y) / 2} L ${cx} ${cy} L ${p1.x} ${p1.y + (p4.y - p1.y) / 2} L ${p1.x} ${p1.y}`;
        }
        $path.plot(d);
        e.target.instance.x(textX + ex).y(textY + ey);
      })
    },
    getDistance (p1, p2) {
      let xs = p2.x - p1.x;
      xs = xs * xs;
      let ys = p2.y - p1.y;
      ys = ys * ys;
      return Math.sqrt(xs + ys);
    },
    onShowSs () {
      this.extCPTValue = true;
    },
    onDeleteSs (index) {
      let point = this.ss[index];
      this.ss.splice(index, 1);
      point.update({ dataLabels: { enabled: false } });
    }
  }
}